<template>
  <progress
    :class="$style.progress"
    :value="value"
    :max="max"
  />
</template>

<script>
export default {
  name: 'BaseProgress',
  props: {
    value: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="sass" module>
  .progress
    +size(100%, 10px)
    appearance: none
    margin-bottom: -3px
    background-size: auto
    overflow: hidden
    border: none
    border-radius: 5px

    &::-webkit-progress-bar
      background: rgba(33, 33, 33, 0.1)

    &::-webkit-progress-value,
      background: linear-gradient(249.76deg, #37B55E -8.32%, #7BD3FF 108.85%), #FFFFFF
      border-radius: 5px

    &::-moz-progress-bar
      background: linear-gradient(249.76deg, #37B55E -8.32%, #7BD3FF 108.85%), #FFFFFF
      border-radius: 5px
</style>
